module.exports = __webpack_public_path__ + "static/media/image2.dbf4bd04.jpg";